import { Pipe, PipeTransform } from '@angular/core';
import { ICity } from 'src/app/models/city';

@Pipe({
  name: 'city'
})
export class CityPipe implements PipeTransform {

  transform(value: ICity, ...args: any[]): string {
    if (value.state !== undefined) {
      return value.name + ', ' +
        value.state + ', ' +
        value.country;
    } else {
      return value.name + ', ' + value.country;
    }
  }

}
